import isFinite from 'lodash/isFinite';

// NaN/Infinity → undefined.
export function finiteOrUndefined(value: number | undefined): number | undefined {
    return isFinite(value) ? value : undefined;
}
